import React from 'react';

import BaseIcon, { BaseIconProps } from './BaseIcon';

const ArrowRightIcon = ({ viewBox, ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} viewBox={viewBox || '0 0 16 12'}>
    <path
      d="M15.3653 6.56015L10.3853 11.5602C10.2253 11.7202 10.0253 11.8002 9.82527 11.8002C9.62527 11.8002 9.42527 11.7202 9.26527 11.5602C8.94527 11.2402 8.94527 10.7401 9.26527 10.4201L12.8853 6.78015H1.20527C0.765273 6.78015 0.405273 6.42015 0.405273 5.98015C0.405273 5.54015 0.765273 5.18015 1.20527 5.18015H12.8853L9.26527 1.54016C8.94527 1.22016 8.94527 0.720156 9.26527 0.400156C9.58527 0.0801563 10.0853 0.0801563 10.4053 0.400156L15.3853 5.40016C15.6853 5.74016 15.6853 6.26015 15.3653 6.56015Z"
      fill="white"
    />
  </BaseIcon>
);

export default ArrowRightIcon;
